export const videos = [
  {
    id: 'a01',
    title: '新番速递：《星海远征》第一集高能开场',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20sci-fi%20space%20battle%20scene%20with%20glowing%20spaceships%2C%20deep%20blue%20and%20orange%20energy%20trails%2C%20digital%20illustration%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=450&seq=v-a01&orientation=landscape',
    category: 'animation',
    duration: '12:45',
    views: 1286000,
    publishedAt: '2026-10-12',
    author: '星海放映室',
    description:
      '本季最受期待的科幻新番《星海远征》正式开播，第一集就交出顶级制作水准。少年驾驶员临危受命，驾驶旧式机甲冲向战场，开场十分钟的舰队交火直接拉满。',
    recommendReason: '本季新番播放量第一，机甲战与世界观同步展开，新人也能零门槛入坑。',
    tags: ['新番', '科幻', '机甲'],
    featured: true,
    hot: true,
  },
  {
    id: 'a02',
    title: '热血名场面：少年觉醒的瞬间',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20hero%20awakening%20moment%20with%20glowing%20aura%2C%20orange%20energy%20burst%20against%20dark%20blue%20background%2C%20dynamic%20action%20pose%2C%20digital%20illustration&width=800&height=450&seq=v-a02&orientation=landscape',
    category: 'animation',
    duration: '08:20',
    views: 976000,
    publishedAt: '2026-10-10',
    author: '热血剪辑铺',
    description:
      '把近年最燃的"觉醒名场面"一次看完。从默默无闻到全开光环，配乐一响，画面一白，谁还不是个少年。',
    recommendReason: '高燃切片合集，三分钟一高潮，适合快速提神。',
    tags: ['热血', '名场面', '混剪'],
    hot: true,
  },
  {
    id: 'a03',
    title: '治愈系日常番混剪：冬日暖阳',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20anime%20room%20in%20winter%20with%20warm%20sunlight%2C%20soft%20orange%20tones%20and%20muted%20blue%20shadows%2C%20peaceful%20slice%20of%20life%20illustration%2C%20clean%20composition&width=800&height=450&seq=v-a03&orientation=landscape',
    category: 'animation',
    duration: '15:02',
    views: 412000,
    publishedAt: '2026-10-08',
    author: '慢生活频道',
    description:
      '忙碌一天后最需要的十分钟。精选治愈系日常番温柔片段，配上一杯热饮，让情绪慢下来。',
    recommendReason: '解压首选，评论区一致好评的"电子布洛芬"。',
    tags: ['治愈', '日常', '解压'],
  },
  {
    id: 'a04',
    title: '机甲战斗合集：钢铁与火焰的碰撞',
    cover:
      'https://readdy.ai/api/search-image?query=giant%20mecha%20robot%20battle%20scene%2C%20steel%20armor%20with%20orange%20flames%20and%20deep%20blue%20night%20city%2C%20epic%20scale%2C%20detailed%20digital%20illustration&width=800&height=450&seq=v-a04&orientation=landscape',
    category: 'animation',
    duration: '11:38',
    views: 688000,
    publishedAt: '2026-10-06',
    author: '硬核机体研究所',
    description:
      '从经典到新作，盘点动画史上最震撼的机甲对决。钢铁洪流、光束齐射，男人的浪漫一次看够。',
    recommendReason: '机甲党必看，含多部经典作品对比解析。',
    tags: ['机甲', '战斗', '合集'],
    hot: true,
  },
  {
    id: 'a05',
    title: '校园恋爱番高甜片段：心动警告',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20school%20romance%20scene%20under%20cherry%20blossoms%2C%20warm%20pink%20orange%20light%20with%20soft%20blue%20sky%2C%20sweet%20atmosphere%2C%20illustration&width=800&height=450&seq=v-a05&orientation=landscape',
    category: 'animation',
    duration: '09:47',
    views: 523000,
    publishedAt: '2026-10-04',
    author: '甜度检测站',
    description:
      '樱花树下、天台夕阳、雨中共伞……把恋爱番里最让人心跳漏拍的瞬间剪在一起，甜到齁。',
    recommendReason: '高甜名场面集中放送，弹幕区集体姨母笑。',
    tags: ['恋爱', '校园', '甜'],
  },
  {
    id: 'a06',
    title: '国漫崛起：3D 打斗特效解析',
    cover:
      'https://readdy.ai/api/search-image?query=chinese%203d%20animation%20martial%20arts%20battle%20with%20orange%20energy%20effects%20on%20deep%20blue%20background%2C%20cinematic%20composition%2C%20high%20detail%20render&width=800&height=450&seq=v-a06&orientation=landscape',
    category: 'animation',
    duration: '13:55',
    views: 731000,
    publishedAt: '2026-10-02',
    author: '国漫观察',
    description:
      '近年国漫 3D 打斗特效水准飞跃提升，本期逐帧拆解几部代表作的动作设计与镜头语言，看国产动画怎么"打"出来。',
    recommendReason: '技术流解析，边看边学镜头感，含大量名场面。',
    tags: ['国漫', '特效', '解析'],
    hot: true,
  },
  {
    id: 'a07',
    title: '催泪神作结局回顾：最后一幕',
    cover:
      'https://readdy.ai/api/search-image?query=emotional%20anime%20final%20scene%20with%20lone%20figure%20under%20deep%20blue%20dusk%20sky%20and%20warm%20orange%20horizon%2C%20melancholic%20mood%2C%20illustration&width=800&height=450&seq=v-a07&orientation=landscape',
    category: 'animation',
    duration: '14:30',
    views: 358000,
    publishedAt: '2026-09-30',
    author: '催泪警报',
    description:
      '有些结局看一次哭一次。本期回顾几部经典动画的最后一幕，BGM 一响，纸巾备好。',
    recommendReason: '情绪浓度拉满，务必自备纸巾与安静环境。',
    tags: ['催泪', '结局', '回顾'],
  },
  {
    id: 'a08',
    title: '二次元 OP/ED 神曲串烧',
    cover:
      'https://readdy.ai/api/search-image?query=anime%20opening%20title%20sequence%20with%20dynamic%20colorful%20abstract%20shapes%2C%20orange%20and%20deep%20blue%20gradient%2C%20energetic%20graphic%20design%20style&width=800&height=450&seq=v-a08&orientation=landscape',
    category: 'animation',
    duration: '18:12',
    views: 604000,
    publishedAt: '2026-09-28',
    author: '音乐番组',
    description:
      '把近年最抓耳的 OP 和 ED 串成一首"回忆杀"。前奏一响，自动跟唱，青春又回来了。',
    recommendReason: '歌单级体验，通勤路上循环播放首选。',
    tags: ['音乐', 'OP', '回忆'],
  },
  {
    id: 'a09',
    title: '异世界题材爆笑名场面',
    cover:
      'https://readdy.ai/api/search-image?query=comedy%20fantasy%20anime%20scene%20with%20exaggerated%20reaction%20faces%2C%20bright%20orange%20accents%20and%20deep%20blue%20background%2C%20playful%20illustration&width=800&height=450&seq=v-a09&orientation=landscape',
    category: 'animation',
    duration: '10:24',
    views: 447000,
    publishedAt: '2026-09-26',
    author: '沙雕事务所',
    description:
      '异世界题材看多了，笑点也多了。本期集合各种"穿越就翻车"的爆笑瞬间，笑到肚子疼。',
    recommendReason: '下饭神片，弹幕密度全场最高之一。',
    tags: ['搞笑', '异世界', '名场面'],
  },
  {
    id: 'g01',
    title: '新游速评：《暗影黎明》开荒实测',
    cover:
      'https://readdy.ai/api/search-image?query=dark%20fantasy%20action%20game%20screenshot%20with%20glowing%20orange%20runes%20and%20deep%20blue%20fog%2C%20epic%20atmosphere%2C%20stylized%20render&width=800&height=450&seq=v-g01&orientation=landscape',
    category: 'game',
    duration: '22:10',
    views: 892000,
    publishedAt: '2026-10-13',
    author: '开荒小队',
    description:
      '年度期待作《暗影黎明》正式上线，本期第一时间开荒实测：职业选择、前期资源、Boss 难点一次讲清，帮你少走弯路。',
    recommendReason: '首发实测攻略，开荒前必看，含关键难点速通思路。',
    tags: ['新游', '速评', '开荒'],
    featured: true,
    hot: true,
  },
  {
    id: 'g02',
    title: '五杀集锦：极限反杀的瞬间',
    cover:
      'https://readdy.ai/api/search-image?query=esports%20arena%20highlight%20moment%20with%20explosive%20orange%20effects%20and%20deep%20blue%20stage%20lights%2C%20dynamic%20motion%2C%20stylized%20graphic&width=800&height=450&seq=v-g02&orientation=landscape',
    category: 'game',
    duration: '07:35',
    views: 1154000,
    publishedAt: '2026-10-11',
    author: '高光回收站',
    description:
      '残血一打五一波带走！本期精选本月最精彩的反杀与五杀镜头，配合慢放回放，看高手怎么读局面。',
    recommendReason: '节奏紧凑、爽点密集，本月播放最高的游戏集锦。',
    tags: ['集锦', '五杀', '高光'],
    hot: true,
  },
  {
    id: 'g03',
    title: '开放世界探索之旅：绝美风景盘点',
    cover:
      'https://readdy.ai/api/search-image?query=open%20world%20game%20landscape%20with%20mountains%20and%20sunset%2C%20warm%20orange%20sky%20meeting%20deep%20blue%20valleys%2C%20painterly%20game%20render%2C%20wide%20vista&width=800&height=450&seq=v-g03&orientation=landscape',
    category: 'game',
    duration: '16:48',
    views: 536000,
    publishedAt: '2026-10-09',
    author: '漫步地图',
    description:
      '不急着做任务，先好好看看这个世界。本期带你走遍几款开放世界游戏最惊艳的取景地，随手一截都是壁纸。',
    recommendReason: '视觉党与截图党福利，放松向观看体验。',
    tags: ['开放世界', '风景', '探索'],
  },
  {
    id: 'g04',
    title: '硬核魂类 BOSS 战无伤通关',
    cover:
      'https://readdy.ai/api/search-image?query=souls-like%20game%20boss%20fight%20with%20towering%20creature%20and%20orange%20ember%20particles%20on%20deep%20blue%20dark%20arena%2C%20tense%20atmosphere&width=800&height=450&seq=v-g04&orientation=landscape',
    category: 'game',
    duration: '19:26',
    views: 673000,
    publishedAt: '2026-10-07',
    author: '无伤研究所',
    description:
      '一次次死亡只为一次完美。本期带来魂类 BOSS 的无伤通关全过程，附翻滚时机与出招读谱讲解。',
    recommendReason: '硬核玩家的技术盛宴，讲解细致可学。',
    tags: ['魂类', '无伤', '攻略'],
    hot: true,
  },
  {
    id: 'g05',
    title: '电竞名场面：逆转翻盘时刻',
    cover:
      'https://readdy.ai/api/search-image?query=esports%20stadium%20with%20crowd%20and%20glowing%20orange%20and%20deep%20blue%20light%20beams%2C%20dramatic%20comeback%20moment%2C%20stylized%20illustration&width=800&height=450&seq=v-g05&orientation=landscape',
    category: 'game',
    duration: '12:04',
    views: 758000,
    publishedAt: '2026-10-05',
    author: '赛场转播',
    description:
      '落后一万经济也能翻？本期回顾职业赛场上最不可思议的逆转名场面，解说喊到破音的那种。',
    recommendReason: '燃到起鸡皮疙瘩，电竞迷的集体回忆。',
    tags: ['电竞', '逆转', '名场面'],
  },
  {
    id: 'g06',
    title: '游戏彩蛋大合集：你发现了吗',
    cover:
      'https://readdy.ai/api/search-image?query=hidden%20easter%20egg%20in%20video%20game%2C%20mysterious%20glowing%20orange%20object%20in%20deep%20blue%20cave%2C%20intriguing%20detail%2C%20stylized%20render&width=800&height=450&seq=v-g06&orientation=landscape',
    category: 'game',
    duration: '14:52',
    views: 394000,
    publishedAt: '2026-10-03',
    author: '细节猎人',
    description:
      '藏在角落里的秘密最迷人。本期盘点各款游戏里的隐藏彩蛋与开发者玩笑，看完直呼"原来还能这样"。',
    recommendReason: '细节控最爱，边看边涨知识。',
    tags: ['彩蛋', '细节', '合集'],
  },
  {
    id: 'g07',
    title: '沙盒建造神作：玩家作品鉴赏',
    cover:
      'https://readdy.ai/api/search-image?query=voxel%20sandbox%20game%20city%20built%20by%20players%2C%20warm%20orange%20sunset%20over%20deep%20blue%20blocks%2C%20creative%20architecture%2C%20stylized%20render&width=800&height=450&seq=v-g07&orientation=landscape',
    category: 'game',
    duration: '17:19',
    views: 421000,
    publishedAt: '2026-10-01',
    author: '方块工坊',
    description:
      '别人玩游戏，他们造世界。本期参观玩家在沙盒游戏里建起的城市、城堡与太空港，震撼程度不输专业建筑。',
    recommendReason: '创意爆棚，适合与朋友一起边看边讨论。',
    tags: ['沙盒', '建造', '创意'],
  },
  {
    id: 'g08',
    title: '独立游戏推荐：被低估的宝藏',
    cover:
      'https://readdy.ai/api/search-image?query=artistic%20indie%20game%20scene%20with%20hand-painted%20style%2C%20warm%20orange%20and%20deep%20blue%20palette%2C%20dreamy%20atmosphere%2C%20illustration&width=800&height=450&seq=v-g08&orientation=landscape',
    category: 'game',
    duration: '20:36',
    views: 287000,
    publishedAt: '2026-09-29',
    author: '宝藏挖掘机',
    description:
      '没有大厂宣传，却让人一玩难忘。本期推荐几款被低估的独立游戏，玩法新奇、美术惊艳，性价比极高。',
    recommendReason: '小众精品合集，帮你找到下一个心头好。',
    tags: ['独立游戏', '推荐', '宝藏'],
  },
  {
    id: 'g09',
    title: '手游操作天花板：极限连招演示',
    cover:
      'https://readdy.ai/api/search-image?query=mobile%20action%20game%20combo%20with%20orange%20skill%20effects%20and%20deep%20blue%20background%2C%20fast%20motion%20blur%2C%20stylized%20graphic%20design&width=800&height=450&seq=v-g09&orientation=landscape',
    category: 'game',
    duration: '09:12',
    views: 519000,
    publishedAt: '2026-09-27',
    author: '指尖操作组',
    description:
      '手机也能打出天花板操作。本期演示手游里的极限连招与走位，附按键设置与手感调校建议。',
    recommendReason: '实用技巧向，想提升操作的玩家别错过。',
    tags: ['手游', '连招', '技巧'],
  },
  {
    id: 'c01',
    title: '经典动作片：街头追车戏',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20car%20chase%20in%20city%20at%20night%2C%20orange%20street%20lights%20and%20deep%20blue%20shadows%2C%20motion%20blur%2C%20movie%20still%20aesthetic&width=800&height=450&seq=v-c01&orientation=landscape',
    category: 'clip',
    duration: '06:28',
    views: 968000,
    publishedAt: '2026-10-14',
    author: '电影碎片',
    description:
      '不用看整部片，先看最过瘾的一段。本片段剪辑经典动作片的街头追车戏，油门一踩，肾上腺素飙升。',
    recommendReason: '高燃动作片段，几分钟看完电影精华。',
    tags: ['动作', '追车', '经典'],
    featured: true,
    hot: true,
  },
  {
    id: 'c02',
    title: '科幻大片：太空电梯名场面',
    cover:
      'https://readdy.ai/api/search-image?query=sci-fi%20space%20elevator%20scene%20with%20giant%20structure%20against%20deep%20blue%20earth%20and%20orange%20sunrise%2C%20epic%20cinematic%20scale%2C%20movie%20concept%20art&width=800&height=450&seq=v-c02&orientation=landscape',
    category: 'clip',
    duration: '05:44',
    views: 812000,
    publishedAt: '2026-10-12',
    author: '科幻放映厅',
    description:
      '当人类把电梯修到天上。本片段精选科幻大片里最具想象力的太空工程名场面，画面宏大得让人屏息。',
    recommendReason: '视觉震撼，科幻迷的快乐源泉。',
    tags: ['科幻', '太空', '名场面'],
    hot: true,
  },
  {
    id: 'c03',
    title: '悬疑片高能反转片段',
    cover:
      'https://readdy.ai/api/search-image?query=mystery%20thriller%20movie%20scene%20with%20single%20silhouette%20under%20cold%20deep%20blue%20light%20and%20orange%20lamp%2C%20suspenseful%20mood%2C%20cinematic&width=800&height=450&seq=v-c03&orientation=landscape',
    category: 'clip',
    duration: '07:16',
    views: 654000,
    publishedAt: '2026-10-10',
    author: '反转档案馆',
    description:
      '看到最后一秒才恍然大悟。本片段集合悬疑片里最让人起鸡皮疙瘩的反转瞬间，注意别眨眼。',
    recommendReason: '反转控必看，评论区集体"没想到"。',
    tags: ['悬疑', '反转', '高能'],
  },
  {
    id: 'c04',
    title: '武侠电影：竹林对决',
    cover:
      'https://readdy.ai/api/search-image?query=wuxia%20bamboo%20forest%20swordfight%20scene%2C%20green%20bamboo%20with%20warm%20orange%20light%20and%20deep%20blue%20mist%2C%20elegant%20martial%20arts%20choreography%2C%20cinematic&width=800&height=450&seq=v-c04&orientation=landscape',
    category: 'clip',
    duration: '08:02',
    views: 489000,
    publishedAt: '2026-10-08',
    author: '武侠影志',
    description:
      '竹叶纷飞，剑光如练。本片段精选武侠电影里最诗意的竹林对决，招式与意境兼具，看得人如痴如醉。',
    recommendReason: '东方美学的极致呈现，值得慢慢品。',
    tags: ['武侠', '对决', '美学'],
  },
  {
    id: 'c05',
    title: '喜剧电影爆笑名场面合集',
    cover:
      'https://readdy.ai/api/search-image?query=comedy%20movie%20scene%20with%20exaggerated%20funny%20moment%2C%20bright%20orange%20light%20and%20deep%20blue%20background%2C%20playful%20cinematic%20still&width=800&height=450&seq=v-c05&orientation=landscape',
    category: 'clip',
    duration: '10:38',
    views: 723000,
    publishedAt: '2026-10-06',
    author: '笑点收集器',
    description:
      '不开心的时候就看这个。本合集把喜剧电影里最好笑的桥段剪在一起，从头笑到尾，解压效果拉满。',
    recommendReason: '下饭下酒两相宜，笑点密集不冷场。',
    tags: ['喜剧', '爆笑', '合集'],
    hot: true,
  },
  {
    id: 'c06',
    title: '战争片：热血冲锋片段',
    cover:
      'https://readdy.ai/api/search-image?query=war%20movie%20charge%20scene%20with%20soldiers%20silhouettes%2C%20orange%20explosions%20against%20deep%20blue%20smoke%2C%20dramatic%20cinematic%20scale&width=800&height=450&seq=v-c06&orientation=landscape',
    category: 'clip',
    duration: '09:24',
    views: 577000,
    publishedAt: '2026-10-04',
    author: '战争影像',
    description:
      '冲锋号一响，热血就上头。本片段精选战争大片里最震撼的冲锋场景，激烈与悲壮并存。',
    recommendReason: '震撼人心的战争场面，代入感极强。',
    tags: ['战争', '冲锋', '热血'],
  },
  {
    id: 'c07',
    title: '经典台词混剪：那些年我们记住的话',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20montage%20collage%20of%20movie%20scenes%2C%20warm%20orange%20and%20deep%20blue%20color%20grading%2C%20nostalgic%20film%20strip%20aesthetic&width=800&height=450&seq=v-c07&orientation=landscape',
    category: 'clip',
    duration: '11:50',
    views: 445000,
    publishedAt: '2026-10-02',
    author: '台词收藏夹',
    description:
      '有些台词，看过一遍就再也忘不掉。本期把经典电影里最戳心的对白剪成一支片子，献给爱电影的你。',
    recommendReason: '情怀拉满，适合安安静静看完。',
    tags: ['台词', '混剪', '情怀'],
  },
  {
    id: 'c08',
    title: '超级英雄集结高燃片段',
    cover:
      'https://readdy.ai/api/search-image?query=superhero%20team%20assembled%20heroic%20pose%2C%20orange%20energy%20glow%20against%20deep%20blue%20sky%2C%20epic%20comic%20movie%20aesthetic&width=800&height=450&seq=v-c08&orientation=landscape',
    category: 'clip',
    duration: '08:46',
    views: 691000,
    publishedAt: '2026-09-30',
    author: '英雄集结号',
    description:
      '当英雄们站到一起，那个镜头就是全片最高光。本片段精选超级英雄集结的高燃瞬间，配合 BGM 直接封神。',
    recommendReason: '情怀与热血并存，高燃片段一次看够。',
    tags: ['超级英雄', '高燃', '集结'],
  },
  {
    id: 'c09',
    title: '港片黄金年代：警匪对峙',
    cover:
      'https://readdy.ai/api/search-image?query=hong%20kong%20crime%20movie%20standoff%20scene%2C%20two%20figures%20in%20deep%20blue%20alley%20with%20warm%20orange%20neon%2C%20gritty%20cinematic%20mood&width=800&height=450&seq=v-c09&orientation=landscape',
    category: 'clip',
    duration: '07:58',
    views: 512000,
    publishedAt: '2026-09-28',
    author: '港片重映',
    description:
      '霓虹闪烁的老香港，警察与悍匪隔着一条街对峙。本片段精选港片黄金年代的警匪名场面，够味够劲。',
    recommendReason: '港片迷的怀旧时刻，氛围感拉满。',
    tags: ['港片', '警匪', '怀旧'],
  },
];